module.exports = __webpack_public_path__ + "static/media/tape_sealing.6c4683b6.png";